import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { CompanyTypeDataForm } from '../../../../app/models/CompanyType';
import { SectorDataForm } from '../../../../app/models/Sector';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { SectorBusinessRulesEnum } from '../../../../app/shared/enums';

type Props = {
    sectorDataForm: SectorDataForm;
    setSectorDataForm: (sector: SectorDataForm) => void;
    errorFields?: any;
    sectorBusinessRulesEnum:  SectorBusinessRulesEnum[]

};

const SectorForm = ({ sectorDataForm, setSectorDataForm, errorFields, sectorBusinessRulesEnum }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> 
         | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setSectorDataForm({ ...sectorDataForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {

        setSectorDataForm({ ...sectorDataForm, [name]: value });
    };
    

    return (
        <form>
            <div className="row">
                <div className="mb-2 row needs-validation">
                    <label className="col-md-12 col-form-label">Nombre</label>
                    <div className="col-md-12">
                        <input
                            name="name"
                            id="name"
                            type="text"
                            className={`form-control ${fieldHasError('name')}`}
                            value={sectorDataForm.name}
                            onChange={handleChange}
                            onFocus={() => onFocusRemove('name')}
                            placeholder="Ingrese nombre del sector"
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('name')}
                        </div>
                    </div>
                </div>

                <div className="mb-2 row">
                    
                <label className="col-md-12 col-form-label">Regla de Sector</label>
                    <div className="col-md-12">
                        <SelectTwo
                            name="sector_business_rules_enum"
                            id="sector_business_rules_enum"
                            inputValue={sectorDataForm.sector_business_rules_enum}
                            hasError={fieldHasError('sector_business_rules_enum') !== ''}
                            options={SelectTwoMapperOptions(sectorBusinessRulesEnum)}
                            onChange={(value: any) =>
                                handleChangeSelectTwo('sector_business_rules_enum', value.value)
                            }
                            onFocus={() => onFocusRemove('sector_business_rules_enum')}
                            placeholder="Seleccione regla asociada al sector"
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('sector_business_rules_enum')}
                        </div>
                    </div>
                </div>
    
            </div>

        </form>
    );
};

export default SectorForm;
